import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import FileTable from '../tables/FileTable'

class ViewHistoryModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            files: [],
            files_updated: false,
            ...props
        }
    }

    componentDidMount = () => {
        this.getDocumentHistory(this.props.file)
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.file !== prevProps.file)
            this.getDocumentHistory(this.props.file)
    }

    refresh = () => {
        this.getDocumentHistory(this.props.file);
    }

    getDocumentHistory = (file) => {
        fetch(window.location.protocol + '//' + window.location.host + `/api/archive/history?document_ref=${file.DocumentRef}&document_type=${file.DocumentType}&folder=${file.Folder}`)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        files: result,
                        files_updated: true
                    })
                })
            .catch(error => {
                console.error(error)
            });
    }

    render() {
        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>
                    Document History
                </ModalHeader>
                <ModalBody>
                    <FileTable
                        viewPortfolio={false}
                        refresh={this.refresh}
                        DocumentType={this.props.file.DocumentType}
                        DocumentRef={this.props.file.DocumentType}
                        files={this.state.files}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={this.props.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default ViewHistoryModal;